/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum ExportCaseCorrectionResult {
  Success = 0,
  Error = 1,
  ValidationFailed = 2,
  NotFound = 3,
  SaveFailed = 4,
}
